import React, { useEffect, useState } from "react";
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ins1Image from '../assets/img/exam/ins1.png'

const testSeriesData = [
  {
    logo: ins1Image,
    users: '1850.8k Users',
    title: 'NEET UG Mock Test Series 2025',
    totalTests: '1161 Total Tests',
    freeTests: '9 Free Tests',
    languages: 'English, Hindi + 6 More',
    points: [
      '91 ALP & SI 2024 PYP Qs',
      '3 ALP & SI 2024 PYP Repeated Qs',
      '5 Railway Latest Pattern FT',
      '+1062 more tests',
    ],
  },
  // Duplicate or change for more slides...
];

const carouselOptions = {
    loop: true,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 3000, // autoplay every 3 seconds
    autoplayHoverPause: true, // pause on mouse hover
    dots: false,
    nav: false,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
      1200: { items: 4 },
    },
  };
  
  const TestSeriesSection = () => {
      const [testSeriesData1, settestSeriesData1] = useState([]);
        const [loading, setLoading] = useState(true);  // Handle loading state
    
        const fetchWallOfFame = async () => {
          try {
            const response = await axios.get(`${API_BASE_URL}/getMostPreferredTestSeries`);
          
            settestSeriesData1(response.data);
          } catch (err) {
            console.error("Error fetching data:", err);
          } finally {
            setLoading(false);
          }
        };
      
        useEffect(() => {
          fetchWallOfFame();
        }, []); 
        console.log("test hggggg1",testSeriesData1)
    return (
      <section className="test_series_pd pb-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="site-heading text-left">
                <h2 className="site-title">Most Preferred Test Series</h2>
              </div>
            </div>
  
            <OwlCarousel className="test_series-slider owl-theme" {...carouselOptions}>
              {testSeriesData1.map((item, index) => (
                <div className="test_series" key={index}>
                  <div className="tst_logo_wrap">
                    <div className="logo_tst_srs">
                     <img src={`${Image_Base_Url}${item.media_image_path}`} alt="media_image_path" />
                    </div>
                    <div className="usr_count">{item.user_count}</div>
                  </div>
  
                  <p className="pt-2 pb-3">{item.title}</p>
  
                  <p className="total_test_wraper">
                    <span className="tst_wrap_txt">{item.total_tests}</span>
                    <span className="tst_wrap_txt grn_wrap">{item.free_tests}</span>
                  </p>
  
                  <p className="orange pt-2 highligt_orng">{item.languages}</p>
  
                  <ul>
                    {/* {item.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))} */}
                     <td dangerouslySetInnerHTML={{ __html: item.description}} />
                  </ul>
  
                  <a href="#" className="theme-btn">View Test Series</a>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </div>
      </section>
    );
  };
  
  export default TestSeriesSection;
